import { OrbitControls, PerspectiveCamera } from "@react-three/drei";
import { Canvas } from "@react-three/fiber";
import { useContext, useEffect } from "react";
import {
  ColorContext,
  ConfigurationContext,
  WingConfigurationContext,
} from "../../App";
import { getSizesByWindow } from "../../utils/Utils";
import CanvasEnvironment from "./CanvasEnvironment";
import NarrowScene from "./NarrowScene";

function Viewer(props) {
  const { currentConfiguration, setCurrentConfiguration } =
    useContext(ConfigurationContext);
  const { wingConfiguration } = useContext(WingConfigurationContext);
  const { currentColor } = useContext(ColorContext);
  useEffect(() => {
    const wallSize = getSizesByWindow(props.currentWindow);
    setCurrentConfiguration((prevState) => {
      return {
        wall: {
          originalWidth: wallSize[2],
          originalHeight: wallSize[3],
          width: wallSize[0],
          height: wallSize[1],
        },
        window: {
          ...prevState.window,
        },
      };
    });
  }, [props.currentWindow]);

  const targetByPosition = () => (props.largeWall ? 0.5 : 1.5);

  return (
    <Canvas
      gl={{
        antialias: true,
        preserveDrawingBuffer: true,
        physicallyCorrectLights: true,
        toneMappingExposure: 1.5,
      }}
    >
      <ambientLight color={0x8fbcd4} intensity={4} />
      <PerspectiveCamera
        makeDefault
        fov={45}
        near={0.25}
        far={100}
        position={[0, 1, 8]}
      />
      <OrbitControls
        enableDamping={false}
        makeDefault
        scale={[0, 1.2, 0]}
        maxPolarAngle={Math.PI * 0.495}
        maxDistance={10}
        minDistance={1}
        target-y={1}
      />
      <NarrowScene
        configuration={currentConfiguration.wall}
        color={currentColor}
        currentWindow={props.currentWindow}
        wingConfiguration={wingConfiguration}
        scale={1}
        position={[0, -0.5, 0]}
        largeWall={true}
        visible={!props.largeWall}
      />
      <CanvasEnvironment />
    </Canvas>
  );
}

export default Viewer;
